import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/constants/languages';

export const getLanguageFromPath = (pathname: string) => {
	const langFromPath = pathname.split('/')[1];
	return SUPPORTED_LANGUAGES.includes(langFromPath) ? langFromPath : DEFAULT_LANGUAGE;
};
